export default __webpack_public_path__ + "static/media/img-stack-for-value.aaef8e3d.png";